import { G } from "../../constants/theme";

export default function BigTitle({ children, size = "clamp(36px,4.5vw,62px)" }) {
  return (
    <h2
      style={{
        fontFamily: "'Bebas Neue', sans-serif",
        fontSize: size,
        color: G.white,
        letterSpacing: 1,
        lineHeight: 0.95,
        marginBottom: 16,
      }}
    >
      {children}
    </h2>
  );
}
